import { cdnTemplate } from 'cdnPreprocessor';

export default [
  function RegisterFormDirective() {
    return {
      restrict: 'E',
      controller: 'RegisterCtrl',
      controllerAs: 'register',
      bindToController: true,
      templateUrl: cdnTemplate('/register-form.html'),
      transclude: true,
      scope: {
        redirecting: '=?',
        partnerId: '=?'
      }
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/layout-components/account/register/register-form.dir.js